import XDate from 'xdate'
import {
  ResidentPostReportReason,
  ResidentPostType,
} from '../../_types/resident'

const MAX_POST_IMAGES = 4

const MARKETPLACE_CATEGORIES = [
  'Furniture',
  'Electronics',
  'Free stuff',
  'Household',
  'Other',
]

const LOST_FOUND_CATEGORIES = ['Lost', 'Found']

const FEED_CATEGORIES = [
  'General',
  'Noise',
  'Recommendations',
  'Building',
  'Other',
]

/**
 * The category options for a post mode (Lost & Found is lost vs found;
 * Marketplace is item kinds; Feed is conversation topics).
 *
 * @param {ResidentPostType} postType - the post mode
 * @returns {string[]} the selectable categories
 */
const getCategoryOptions = (postType: ResidentPostType): string[] => {
  if (postType === 'feed') {
    return FEED_CATEGORIES
  }
  if (postType === 'lost-found') {
    return LOST_FOUND_CATEGORIES
  }
  return MARKETPLACE_CATEGORIES
}

const REPORT_REASONS: { value: ResidentPostReportReason; label: string }[] = [
  { value: 'harassment', label: 'Harassment or threats' },
  { value: 'spam', label: 'Spam' },
  { value: 'illegal', label: 'Illegal or prohibited' },
  { value: 'inappropriate', label: 'Inappropriate content' },
  { value: 'other', label: 'Something else' },
]

/**
 * Formats a post/reply timestamp as a short local date (e.g. 'Jun 7').
 *
 * @param {number} createdAt - epoch ms
 * @returns {string}
 */
const formatPostWhen = (createdAt: number): string =>
  new XDate(createdAt).toString('MMM d')

export { MAX_POST_IMAGES, getCategoryOptions, REPORT_REASONS, formatPostWhen }
